import { render } from "./Corporacion.vue?vue&type=template&id=739219a8&scoped=true"
import script from "./Corporacion.vue?vue&type=script&lang=js"
export * from "./Corporacion.vue?vue&type=script&lang=js"

import "./Corporacion.vue?vue&type=style&index=0&id=739219a8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739219a8"]])

export default __exports__